import { Maker } from './maker';

export const MAKERS: Maker[] = [
  {"id":"167","name":"ACURA", "posx" : "0px", "posy":"0px"},
  {"id":"1","name":"ALFA", "posx" : "-150px", "posy":"0px"},
  {"id":"2","name":"AUDI", "posx" : "-300px", "posy":"0px"},
  {"id":"5","name":"BMW", "posx" : "-450px", "posy":"0px"},
  {"id":"8","name":"BUICK", "posx" : "-600px", "posy":"0px"},
  {"id":"9","name":"CADILLAC", "posx" : "-750px", "posy":"0px"},
  {"id":"17","name":"CHEVROLET", "posx" : "0px", "posy":"-150px"},
  {"id":"18","name":"CHRYSLER", "posx" : "-150px", "posy":"-150px"},
  //{"id":"21","name":"DATSUN", "posx" : "-300px", "posy":"-150px"},
  {"id":"24","name":"DODGE", "posx" : "-450px", "posy":"-150px"},
  {"id":"150","name":"FIAT", "posx" : "-600px", "posy":"-150px"},
  {"id":"29","name":"FORD", "posx" : "-750px", "posy":"-150px"},
  {"id":"204","name":"GM", "posx" : "0px", "posy":"-300px"},
  {"id":"32","name":"GMC", "posx" : "-150px", "posy":"-300px"},
  {"id":"36","name":"HONDA", "posx" : "-300px", "posy":"-300px"},
  {"id":"183","name":"HUMMER", "posx" : "-450px", "posy":"-300px"},
  {"id":"37","name":"HYUNDAI", "posx" : "-600px", "posy":"-300px"},
  {"id":"284","name":"INFINITI", "posx" : "-750px", "posy":"-300px"},
  {"id":"43","name":"JAGUAR", "posx" : "0px", "posy":"-450px"},
  {"id":"46","name":"JEEP", "posx" : "-150px", "posy":"-450px"},
  {"id":"157","name":"KIA", "posx" : "-300px", "posy":"-450px"},
  {"id":"53","name":"LAND ROVER", "posx" : "-450px", "posy":"-450px"},
  {"id":"185","name":"LINCOLN", "posx" : "-600px", "posy":"-450px"},
  {"id":"56","name":"MAZDA", "posx" : "-750px", "posy":"-450px"},
  {"id":"58","name":"MERCEDES", "posx" : "0px", "posy":"-600px"},
  {"id":"59","name":"MERCURY", "posx" : "-150px", "posy":"-600px"},
  {"id":"61","name":"MITSUBISHI", "posx" : "-300px", "posy":"-600px"},
  {"id":"63","name":"NISSAN", "posx" : "-450px", "posy":"-600px"},
  {"id":"70","name":"PEUGEOT", "posx" : "-600px", "posy":"-600px"},
  {"id":"76","name":"PONTIAC", "posx" : "-750px", "posy":"-600px"},
  {"id":"77","name":"PORSCHE", "posx" : "0px", "posy":"-750px"},
  {"id":"82","name":"RENAULT", "posx" : "-150px", "posy":"-750px"},
  {"id":"128","name":"SAAB", "posx" : "-300px", "posy":"-750px"},
  {"id":"124","name":"SEAT", "posx" : "-450px", "posy":"-750px"},
  {"id":"208","name":"SMART", "posx" : "-600px", "posy":"-750px"},
  {"id":"168","name":"SUBARU", "posx" : "-750px", "posy":"-750px"},
  {"id":"87","name":"SUZUKI", "posx" : "0px", "posy":"-900px"},
  {"id":"91","name":"TOYOTA", "posx" : "-150px", "posy":"-900px"},
  {"id":"95","name":"VOLKSWAGEN", "posx" : "-300px", "posy":"-900px"},
  {"id":"97","name":"VOLVO", "posx" : "-450px", "posy":"-900px"}
];